const AnnualInspectionSection = () => {
  const inspectionItems = [
    {
      category: '推進システム',
      items: [
        'プロペラの亀裂・欠け・摩耗チェック（4mm以上の欠けがないか）',
        'モーターのガタつき・異音・付着物の確認',
        'スペーサーの取り付け穴の拡大確認',
        'プロペラの裏表・回転方向（CW/CCW）の確認',
      ],
    },
    {
      category: '機体構造',
      items: [
        '機体本体・アーム・ランディングギアの外観破損チェック',
        'カバーの変形・破損・ネジ止め部の確認',
        'フレームの破損・ゴム部品の劣化確認',
        '内部の砂埃・ゴミの清掃（エアブロー）',
      ],
    },
    {
      category: '電力供給システム',
      items: [
        'バッテリー端子部の割れ・腐食・汚れの確認',
        '各コネクターのねじ止め・破損・固定状態',
        '配線の適切な接続と異常の有無',
        '電圧異常・セルバランスの確認',
      ],
    },
    {
      category: '制御システム',
      items: [
        '送受信機の正常動作と通信確認',
        '送信機ディスプレイ・アプリの動作確認',
        'DJI AGRAS APPでのシステムエラー確認',
        'ファームウェアバージョンの確認と更新',
        '飛行テストによる総合チェック',
      ],
    },
  ];

  const insuranceFeatures = [
    '購入時も1年間無償付帯',
    '特別な登録手続き不要',
    '業務中の偶然な事故を補償',
    'ドローン貸与時も借主が補償対象',
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            年次点検で安全飛行を維持
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-3">
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              DJIの整備項目に準拠した徹底的な点検により、機体の安全性を確保します。定期的なメンテナンスは、突然の故障や事故を未然に防ぎ、機体の寿命を延ばします。業務でドローンを使用される方には、年1回の定期点検を強く推奨いたします。
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-8">主な点検項目：</h3>

            <div className="space-y-8">
              {inspectionItems.map((section, index) => (
                <div key={index}>
                  <h4 className="text-xl font-bold text-teal-600 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-checkbox-circle-fill text-teal-600"></i>
                    </span>
                    {section.category}
                  </h4>
                  <ul className="space-y-3 ml-11">
                    {section.items.map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-start text-gray-700">
                        <span className="text-teal-600 mr-3 mt-1">✓</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="bg-[#e7f3ff] border-2 border-blue-400 rounded-xl p-8 sticky top-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                年次点検特典
              </h3>

              <div className="bg-white rounded-lg p-6 mb-6">
                <div className="flex items-center justify-center mb-4">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                    <i className="ri-shield-check-fill text-4xl text-blue-600"></i>
                  </div>
                </div>
                <h4 className="text-xl font-bold text-center text-gray-900 mb-4">
                  🛡️ 損害賠償保険が無償付帯
                </h4>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <span className="font-semibold mr-2">対人補償：</span>
                    <span>最大1億円</span>
                  </li>
                  <li className="flex items-start">
                    <span className="font-semibold mr-2">対物補償：</span>
                    <span>最大5,000万円</span>
                  </li>
                  <li className="flex items-start">
                    <span className="font-semibold mr-2">管理財物補償：</span>
                    <span>修理費を補償</span>
                  </li>
                  <li className="flex items-start">
                    <span className="font-semibold mr-2">追加補償者特約：</span>
                    <span>共同利用者も補償対象</span>
                  </li>
                </ul>
              </div>

              <p className="text-sm text-gray-700 mb-6 leading-relaxed">
                年次点検を受けていただくと、『農業ドローン機体点検証明書』とともに、損害賠償保険の被保険者証が届きます。2年目以降も更新手続きは不要で、毎年の点検で自動的に保険が継続されます。
              </p>

              <div className="bg-white rounded-lg p-6 mb-6">
                <h4 className="font-bold text-gray-900 mb-4">保険の特徴：</h4>
                <ul className="space-y-2">
                  {insuranceFeatures.map((feature, index) => (
                    <li key={index} className="flex items-start text-gray-700">
                      <span className="text-blue-600 mr-2">•</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <button
                onClick={scrollToContact}
                className="w-full bg-teal-600 text-white py-4 rounded-lg hover:bg-teal-700 transition-colors duration-300 font-semibold text-lg whitespace-nowrap"
              >
                点検のご相談はこちら
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnnualInspectionSection;
